import { getCatalogEditorModelPath } from "@/v2-backoffice-client/feature/configuration/feature.configuration.constants"

/**
 * Monaco model for a generic feature's Configuration.
 *
 * Deliberately schema-less: unlike a basemap or a nav layer, a feature of
 * any other type has no single shape to validate against — a 3D building
 * style preset and a search provider share nothing but "some JSON". The
 * editor still parses and formats; it just does not claim to know what
 * belongs in there.
 */
const CONFIGURATION_MODEL_NAME = "feature.configuration.json"

export function getFeatureEditorModelPath(): string {
  return getCatalogEditorModelPath(CONFIGURATION_MODEL_NAME)
}
